"use client";

import { Suspense } from "react";

import { DepictFilter } from "@/lib/hooks/useProductFilter/types";
import FilterModal from "./Filter";

const PlpModals = ({ filters }: { filters: DepictFilter[] }) => {
  return (
    <Suspense fallback="...">
      <FilterModal filters={filters} />
    </Suspense>
  );
};

export default PlpModals;
